import { inject, Injectable } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

import { firstValueFrom, map, shareReplay, startWith, switchMap } from 'rxjs'

import { LanguageCode } from '@ti/contracts'
import { AuthSession, Profile } from '@ti/core/auth/services'
import { I18NConfigProvider } from '@ti/core/contracts/i18n'
import { COUNTRY_SETTINGS } from '@ti/core/ui-kit/i18n/models/data'

import { McpAuthContext } from '../../../mcp/bootstrap/mcp-auth-context'

@Injectable()
export class AdminI18NConfigProvider extends I18NConfigProvider {
  private readonly profile = inject(Profile)
  private readonly authSession = inject(AuthSession)
  private readonly context = inject(McpAuthContext)

  public readonly config$ = this.context.profileEnabled$.pipe(
    switchMap((enabled) =>
      enabled
        ? this.profile.state.pipe(
            map((profile) =>
              profile.language === LanguageCode.English ? COUNTRY_SETTINGS.US : COUNTRY_SETTINGS.MX,
            ),
          )
        : this.authSession.state.currentUserAttributes$.pipe(
            startWith(null),
            map((attributes) => ({
              ...COUNTRY_SETTINGS.US,
              lang: attributes?.language ?? LanguageCode.English,
            })),
          ),
    ),
    takeUntilDestroyed(),
    shareReplay({ bufferSize: 1, refCount: false }),
  )

  public getConfig() {
    return firstValueFrom(this.config$)
  }
}
